exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.attachment-thumbnail[data-v-bf43164c] {\n  cursor: pointer;\n  width: 20%;\n  max-width: 80px;\n  padding-right: 5px;\n}\n@media screen and (min-width: 768px) {\n.attachment-thumbnail[data-v-bf43164c] {\n    padding-right: 10px;\n}\n}\n", "", {"version":3,"sources":["/app/src/components/ReviewAttachments.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;CACpB;AACD;AACA;IACI,oBAAoB;CACvB;CACA","file":"ReviewAttachments.vue","sourcesContent":["\n.attachment-thumbnail[data-v-bf43164c] {\n  cursor: pointer;\n  width: 20%;\n  max-width: 80px;\n  padding-right: 5px;\n}\n@media screen and (min-width: 768px) {\n.attachment-thumbnail[data-v-bf43164c] {\n    padding-right: 10px;\n}\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bf43164c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ReviewAttachments.vue
// module id = 59W4
// module chunks = 4